class SiteNavigationMobile
    extends SiteNavigation
{
    private readonly _site: Site;
    private readonly _siteEvent: (e: CustomEvent) => any;
    
    private _container: SiteContainer | undefined;
    private _containerEvent: ((e: CustomEvent) => any) | undefined;
    private _card: SiteCard | undefined;
    private _cardEvent: ((e: CustomEvent) => any) | undefined;
    private _button?: SiteButton;
    

    constructor(site: Site) {
        super();

        this._site = site;
        this._siteEvent = this._site.on("qts.container", (e: CustomEvent) => {
            this.unregisterContainer();
            this._container = e.detail as SiteContainer;
            this._containerEvent = this._container.on("qts.card", (e: CustomEvent) => {
                this.unregisterCard();
                this._button && this._button.remove();

                this._card = e.detail as SiteCard;
                this._cardEvent = this._card.on("qts.label", (e: CustomEvent) => {
                    this._button && this._button.remove();
                    this.draw(e.detail as ISiteLabel);
                });
            });
        });

        let button = new SiteButton({
            icon: "apps",
            title: site.Config.strings["overview"]
        });
        button.addClass("rounded");
        button.on("click", async () => await site.overview(false));
        this.append(button);
    }
    
    isActive() {
        return this.containsClass("active");
    }
    private draw(label: ISiteLabel) {
        if(this._card === undefined)
            return;
        
        if(this._card.isLastFocusable(label)) {
            this._button = new SiteActionButton(this._card, {
                icon: "check",
                title: this._site.Config.strings["done"],
                action: {
                    type: "Submit"
                },
                isFocusable: false
            });
            this._button.addClass("rounded")
                .addClass("rounded-small");
            this._button.on("click", async () => { 
                label.makeNextActive(); 
            });

            this.append(this._button);
        } else {
            this._button = new SiteButton({
                icon: "keyboard_tab",
                title: this._site.Config.strings["next field"]
            });
            this._button.addClass("rounded")
                .addClass("rounded-small");
            this._button.on("click", async () => { 
                label.makeNextActive(); 
            });

            this.append(this._button);
        }
    }
    makeActive() {
        if(this.isActive())
            return this;
        
        this.addClass("active");
        return this;
    }
    makeInactive() {
        this._button && this._button.remove();
        
        this.removeClass("active");
        return this;
    }
    async remove(removeInner = true) {
        await super.remove(removeInner);

        this._site.off("qts.container", this._siteEvent);
        this.unregisterContainer();
    }

    private unregisterContainer() {
        if(this._container !== undefined && this._containerEvent !== undefined)
            this._container.off("qts.card", this._containerEvent);

        this._container = undefined;
        this._containerEvent = undefined;

        this.unregisterCard();
    }

    private unregisterCard() {
        if(this._card !== undefined && this._cardEvent !== undefined)
            this._card.off("qts.label", this._cardEvent);

        this._card = undefined;
        this._cardEvent = undefined;
    }

}